export enum LoginProvider {
    GOOGLE = 'COGNITO_GOOGLE',
    AMAZON = 'COGNITO_AMAZON',
    FACEBOOK = 'COGNITO_FACEBOOK',
    APPLE = 'COGNITO_APPLE',
    OIDC = 'COGNITO_OIDC'
}
